export const toDecimal = x => {
  const value = parseFloat(x)

  return Math.round(value * 100) / 100
}


export const parsePrice = value => {
  const price = toDecimal(value)

  if (isNaN(price)) {
    throw new Error(`${value} is not a valid price`)
  }

  return price
}

export const parseNullablePrice = value => {
  if (!value) {
    return null
  }

  return parsePrice(value)
}

export const getDiscountValue = (price, msrp) => {
  return Math.round(((msrp - price) / msrp) * 100)
}

export const getDiscountText = (price, msrp) => {
  return `-${getDiscountValue(price, msrp)}%`
}


export const formatLocalePrice = (priceValue, { $site, options })  => {

  const price = parsePrice(priceValue)

  const { locale = 'en_US', isCurrencySymbolPrefix, currencySymbol } = $site.getSiteInfo()

  const fixedLocale = locale === 'es_ES' ? 'en_US' : locale // es站仍然走美金，因此符合美元规范

  const formattedPrice = price.toLocaleString(fixedLocale.replace('_', '-'), options)

  return isCurrencySymbolPrefix ? `${currencySymbol}${formattedPrice}` : `${formattedPrice}${currencySymbol}`

}